jQuery(document).ready(function onPromotionBackgroundAnimationReady($) {
    "use strict";

    var $elements = $('.archive-products__header__background__item');

    if ( $elements.length === 0 ) {
        return;
    }

    var pictures = window.nojesresor_data.images;

    var MIN_ANIMATION_TIME = 7000;
    var MAX_ANIMATION_TIME = 20000;

    if( $(window).width() > 1023 ) {
        start();
    }

    function start() {
        for(var i = 0, l = $elements.length; i < l; ++i) {
            startAnimateOutItem.call($($elements[i]));
        }
    }

    function startAnimateOutItem() {
        setTimeout(animateOutItem.bind(this), randomIntegerRange(MIN_ANIMATION_TIME, MAX_ANIMATION_TIME));
    }

    function animateInItem($item) {
        $item.animate({
            opacity: 0.4
        }, 1000, startAnimateOutItem.bind($item));
    }

    function animateOutItem() {
        this.animate({
            opacity: 0
        }, 1000, changeImageOnItem.bind(this));
    }

    function changeImageOnItem() {
        this.css(
            'background-image',
            'url(' + getRandomImage() + ')'
        );

        animateInItem(this);
    }

    function randomIntegerRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    function getRandomImage() {
        return pictures[randomIntegerRange(0, pictures.length - 1)];
    }
});
